import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 50px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    flex-direction: column;
  }
`;

export const Nav = styled.nav`
  width: 300px;

  button {
    width: 100%;
  }

  ${mediaQuery(BREAKPOINTS.tablet)} {
    width: auto;
  }
`;

export const Content = styled.div`
  flex: 1;
`;

export const ContentText = styled.p`
  margin: 0 0 48px 0;
  max-width: 700px;
`;

export const ContentImage = styled.div`
  img {
    max-width: 100%;
  }
`;
